uic-input-field-number {
  display: inline-flex;
  min-width: var(--uic-input-field-min-width);
  max-width: var(--uic-input-field-max-width);

  > uic-input-field {
    flex: 1 1 auto;
  }
}
